export function FailedStep({
  error,
  onRetry,
  onClose,
}: {
  error: string;
  onRetry: () => void;
  onClose: () => void;
}) {
  return (
    <div style={{ padding: 24, textAlign: "center" }}>
      <div style={{ fontSize: 48, color: "#ff5050" }}>✗</div>
      <div style={{ marginTop: 8 }}>{error || "Relink failed."}</div>
      <div style={{ display: "flex", gap: 8, marginTop: 16, justifyContent: "center" }}>
        <button type="button" className="iris-btn" onClick={onClose}>
          Close
        </button>
        <button type="button" className="iris-btn iris-btn--primary" onClick={onRetry}>
          Try again
        </button>
      </div>
    </div>
  );
}
